import {useEffect} from "react";
import {useInitiateConfigQuery} from "../queries/useInitiateConfigQuery";

type useMatomoType = {
  isConfigLoading: boolean;
}

export default function useMatomo(): useMatomoType {
  const {config} = useInitiateConfigQuery();

  useEffect(() => {
    if (!config) return;

    if (document.location.hostname !== config?.data?.matomoHostname) return;

    const _paq = (window._paq = window._paq || []);
    _paq.push(['setDocumentTitle', document.location.hostname + '/' + document.title]);
    _paq.push(['setCookieDomain', document.location.hostname]);
    _paq.push(['setDomains', [document.location.hostname]]);
    _paq.push(['trackPageView']);
    _paq.push(['enableLinkTracking']);
    const u = 'https://dhigroup.matomo.cloud/';
    _paq.push(['setTrackerUrl', u + 'matomo.php']);
    _paq.push(['setSiteId', '31']);
    const d = document;
    const g = d.createElement('script');
    const s = d.getElementsByTagName('script')[0];
    g.async = true;
    g.src = '//cdn.matomo.cloud/dhigroup.matomo.cloud/matomo.js';
    if (s && s.parentNode) {
      s.parentNode.insertBefore(g, s);
    }
  }, [config]);

  return {
    isConfigLoading: config.isLoading,
  }
}
